import Vue from 'vue'

const TypoInstance = Vue.extend(require('./typo.vue').default);
let instance = null
let typoPromise = null
let typoResolve = null

let getInstance = () => {
  return new TypoInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (typoResolve) {
    typoResolve(null)
    typoResolve = null
  }
  typoPromise = null
}

let Typo = (content) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  typoPromise = new Promise((resolve, reject) => {
    typoResolve = resolve
  })
  instance.open(content, typoResolve)

  return typoPromise
}

export default Typo
